// /src/utils/emailService.js

const API_ENDPOINT = "/send-email.php";

export async function postForm(type, payload = {}) {
  const res = await fetch(API_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    body: JSON.stringify({ form_type: type, ...payload }),
  });

  let data;
  try {
    data = await res.json();
  } catch {
    throw new Error(`Invalid JSON from server (HTTP ${res.status})`);
  }

  if (!res.ok || data?.success !== true) {
    throw new Error(data?.message || `HTTP ${res.status}`);
  }
  return data; // { success: true, message: "..." }
}

// Convenience wrappers
export const sendNewsletterEmail = (d) => postForm("newsletter", d);
export const sendContactEmail = (d) => postForm("contact", d);
export const sendMembershipEmail = (d) => postForm("membership", d);

// -------- Validators (kept) --------
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateFormData = (formType, formData) => {
  const f = formData || {};
  const errors = [];
  const req = (v) => v != null && String(v).trim() !== "";

  switch (formType) {
    case "newsletter": {
      if (!req(f.user_name)) errors.push("First name is required");
      if (!req(f.user_surname)) errors.push("Last name is required");
      if (!req(f.user_email)) errors.push("Email is required");
      else if (!validateEmail(f.user_email)) errors.push("Please enter a valid email address");
      break;
    }
    case "contact": {
      if (!req(f.user_name)) errors.push("Name is required");
      if (!req(f.user_email)) errors.push("Email is required");
      else if (!validateEmail(f.user_email)) errors.push("Please enter a valid email address");
      if (!req(f.message)) errors.push("Message is required");
      break;
    }
 case 'membership': {
  if (!req(f.federation_name)) errors.push('Federation name is required');
  if (!req(f.contact_person))  errors.push('Contact person is required');
  if (!req(f.address))         errors.push('Address is required');
  if (!req(f.phone_number))    errors.push('Phone number is required');

  if (!req(f.user_email)) errors.push('Email is required');
  else if (!validateEmail(f.user_email)) errors.push('Please enter a valid email address');

  // Dates (optional fields - no validation required)
  // Note: Dates are optional, so we don't validate them strictly

  if (f.single_apartments != null && String(f.single_apartments).trim() !== '') {
    if (!/^\d+$/.test(String(f.single_apartments)) || Number(f.single_apartments) < 0) {
      errors.push('Numri i apartamenteve Single duhet të jetë numër i plotë (0 ose më shumë).');
    }
  }
  if (f.double_apartments != null && String(f.double_apartments).trim() !== '') {
    if (!/^\d+$/.test(String(f.double_apartments)) || Number(f.double_apartments) < 0) {
      errors.push('Numri i apartamenteve Double duhet të jetë numër i plotë (0 ose më shumë).');
    }
  }
  if (f.lanes_count != null && String(f.lanes_count).trim() !== '') {
    if (!/^\d+$/.test(String(f.lanes_count)) || Number(f.lanes_count) < 0) {
      errors.push('Numri i Shtigjeve duhet të jetë numër i plotë (0 ose më shumë).');
    }
  }
  break;
}

    default:
      errors.push("Invalid form type");
  }

  return { isValid: errors.length === 0, errors };
};

export default {
  postForm,
  sendNewsletterEmail,
  sendContactEmail,
  sendMembershipEmail,
  validateEmail,
  validateFormData,
};
